// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'view-design'
import 'view-design/dist/styles/iview.css'
import qs from 'qs'
import Button from 'view-design/src/components/button'
import Form from 'view-design/src/components/form'
import FormItem from 'view-design/src/components/form-item'
import Input from 'view-design/src/components/input'
import Row from 'view-design/src/components/row'
import axios from 'axios'
// import moment from 'moment'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import formatDate from '@/utils/formatDate.js'
import qrcode from '@/utils/qrcode.js'

import Cookies from "js-cookie";
// import {createApp } from 'vue';
// import ElementPlus from 'element-plus';
// import 'element-plus/lib/theme-chalk/index.css';
import constants from '../config/constants.js'

// const app = createApp(App);
// app.use(ElementPlus),
// app.mount('#app');

Vue.use(iView)
Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Row)
Vue.use(ElementUI)
Vue.prototype.$qs = qs
Vue.prototype.$axios = axios

Vue.config.productionTip = false
Vue.prototype.$formatDate=formatDate
Vue.prototype.$qrcode=qrcode

// import VueWechatTitle from'vue-wechat-title'    //可以动态修改浏览器标题的插件
// Vue.use(VueWechatTitle); 

// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data: {
    // commonPreUrl: window.location.href.split('/').slice(0, 3).join('/') + '/api/index', // 共享变量
    localUrl: window.location.href.split('/')[2],
    commonPreUrl: window.location.protocol + '//api.cainiaolipin.cn/api',  // 正式 - 根据当前网站协议自动设置
    // commonPreUrl: 'http://cniao.cn/api',
  //  commonPreUrl: 'http://cs.cainiaolipin.cn/api', // 测试
    ycApiUrl: window.location.protocol + '//static.cainiaolipin.cn/', // 云仓API临时域名 - 根据当前网站协议自动设置
    staticUrl: window.location.protocol + '//static.cainiaolipin.cn/', // 静态资源域名 - 根据当前网站协议自动设置
    getUserInfo() { // 共享方法
      const token = Cookies.get("view_userToken");
      const url = this.$root.commonPreUrl + "/index/getUserInfo";
      const res1 = axios.get(url, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });
      res1
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            const resData = resd.data;
            Cookies.set("view_userType", "");
            const userType = resData.user_type;
            if (userType == 3 || userType == "3") {
              Cookies.set("view_userType", "admin", { expires: 1 });
            } else if (userType == 2 || userType == "2") {
              Cookies.set("view_userType", "sub", { expires: 1 });
            }
            
            Cookies.set("view_userId", resData.id, { expires: 1 });
            Cookies.set("view_userName", resData.name, { expires: 1 });
            Cookies.set("view_userBalance", resData.user_balance, { expires: 1 });
            Cookies.set("view_grade", resData.grade, { expires: 1 });
            Cookies.set("view_sendName", resData.send_name, { expires: 1 });
            Cookies.set("view_sendTel", resData.send_tel, { expires: 1 });

            //代理推广页面需用
            Cookies.set("view_url", resData.url, { expires: 1 });
            Cookies.set("view_code", resData.code, { expires: 1 });
            Cookies.set("view_yongjin", resData.yongjin, { expires: 1 });

            // 自动发货页面开关
            if (resData.switch == 0) {
              Cookies.set("view_tbwl_auto", 0, { expires: 1 });
              Cookies.set("view_fhcs_auto", 0, { expires: 1 });
            } else if (resData.switch == 3) {
              Cookies.set("view_tbwl_auto", 1, { expires: 1 });
              Cookies.set("view_fhcs_auto", 1, { expires: 1 });
            } else if (resData.switch == 2) {
              Cookies.set("view_tbwl_auto", 1, { expires: 1 });
              Cookies.set("view_fhcs_auto", 0, { expires: 1 });
            } else if (resData.switch == 1) {
              Cookies.set("view_tbwl_auto", 0, { expires: 1 });
              Cookies.set("view_fhcs_auto", 1, { expires: 1 });
            }
            // 短信自动发送开关
             if (resData.sms_switch == 1) {
              Cookies.set("view_sms_auto", 1, { expires: 1 });
            } else {
              Cookies.set("view_sms_auto", 0, { expires: 1 });
            }
            // 手动发货页面的发件人
            Cookies.set("view_fjr", resData.fjr, { expires: 1 });
            // 绑定页面的uuid
            Cookies.set("view_uuid", resData.uuid, { expires: 1 });
            // 物流轨迹日志页面的点数
            Cookies.set("view_points", resData.points, { expires: 1 });

          } else {
            this.$confirm(resd.msg, "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
              })
              .catch(() => {});
            this.$router.push("/login");
          }
          // this.$router.push("/");
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }
          
          return;
        });
    },
    getSystemInfo(){
      const getUrl = this.$root.commonPreUrl + "/getSystemInfo";
      let local_url = this.localUrl;
      if (local_url == "localhost:8084") {
      //   local_url = "ruyiyuncang.com"
      local_url = "www.cainiaolipin.cn"
      //   local_url = "csryyc.ruyiyuncang.com"
     //   local_url = "vip514255.com"
       // local_url = "cs2.cainiaolipin.cn"
      //  local_url = "ceshi.cainiaolipin.cn"
      } else if (local_url == "view.cainiaolipin.cn") {
        local_url = "www.cainiaolipin.cn"
      } else if(local_url == "cs2.cainiaolipin.cn"){
        // local_url = "www.cainiaolipin.cn"
      };
      let sendData = {
        url: local_url
       //  url: "cs11.cainiaolipin.cn"
      };
      return axios.get(getUrl, {
        params: sendData,
      })
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            const resData = resd.data;
            Cookies.set("view_system_id", resData.id, { expires: 1 });
            Cookies.set("view_site_name", resData.site_name, { expires: 1 });
            Cookies.set("view_site_level", resData.site_level, { expires: 1 });
            Cookies.set("view_icon", resData.icon, { expires: 1 });
            // 下单软件名称 地址   客服微信二维码
            Cookies.set("view_software", resData.software, { expires: 1 });
            Cookies.set("view_software_url", resData.software_url, { expires: 1 });
            Cookies.set("view_qrcode_url", resData.qrcode_url, { expires: 1 });
            // 备案号
            Cookies.set("view_record_number", resData.record_number, { expires: 1 });
            // 联系电话
            Cookies.set("view_mobile", resData.mobile, { expires: 1 });
            // 返回系统信息，供调用者直接使用
            return resData;
          } else {
            this.$confirm(resd.msg, "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
              })
              .catch(() => {});
            this.$router.push("/login");
            return null;
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          
            this.$confirm("网络异常，请稍后刷新重试！", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
          return null;
        });
    },
    removeCookies(){
      Cookies.remove("view_userToken");
      Cookies.remove("view_userName");
      Cookies.remove("view_userBalance");
      Cookies.remove("view_grade");
      Cookies.remove("view_url");
      Cookies.remove("view_code");
      Cookies.remove("view_yongjin");
      Cookies.remove("view_tbwl_auto");
      Cookies.remove("view_fhcs_auto");

      Cookies.remove("view_system_id");
      // Cookies.remove("view_site_name");
      Cookies.remove("view_site_level");
      Cookies.remove("view_icon");
      Cookies.remove("view_software");
      Cookies.remove("view_software_url");
      Cookies.remove("view_qrcode_url");
      Cookies.remove("view_record_number");
      Cookies.remove("view_fjr");
      Cookies.remove("view_uuid");
      Cookies.remove("view_points");
    },
    getUserBalance() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      const url = this.$root.commonPreUrl + "/index/getUserBalance";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
      });

      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            const data = resd.data;
            this.user_balance = data.user_balance;
            if (data.userStrip.length > 0) {
              this.pingtai_data_cang = data.userStrip[0].pingtai_data_cang.split(
                "_",
                1
              )[0];
              this.strip = data.userStrip[0].strip;
            }

            Cookies.remove("view_userBalance");
            Cookies.set("view_userBalance", data.user_balance, { expires: 1 });
            window.location.reload();
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }

          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },
  }
}).$mount('#app');




// WEBPACK FOOTER //
// ./src/main.js